import { render, staticRenderFns } from "./Bubbles.vue?vue&type=template&id=63633a4a&scoped=true&"
import script from "./Bubbles.vue?vue&type=script&lang=js&"
export * from "./Bubbles.vue?vue&type=script&lang=js&"
import style0 from "./Bubbles.vue?vue&type=style&index=0&id=63633a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63633a4a",
  null
  
)

export default component.exports